interface NullForceFn {
  (): void;
  initialize?: () => void;
}

export default function (): NullForceFn {
  function force() {
    // Do nothing!
  }

  force.initialize = function () {
    // Do nothing!
  };

  return force;
}
